module.exports = __webpack_public_path__ + "img/IQ.efc93b37.svg";